import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import useSWR from 'swr';

import { queryParams, withQueryParams } from '@shared/commonFunctions';
import { SERVICES } from '@shared/constants/apiConfig';
import { getSelectActiveTabIndex } from '@store/reducers/tabsSlice';
import { useTabs } from '@shared/hooks/useTabs';

import { requestGetFiles } from '../requests';
import { IContactFile, IContactFileResponse } from '../interfaces';
import { NContact } from '../../Contact/validation';
import { StipsReview } from './StipsReview';

export const StipsReviewScreen = () => {
  const [filesResponse, setFilesResponse] = useState<IContactFileResponse | undefined>(undefined);

  const [contactStipData, setContactStipData] = useState<IContactFile | null>(null);
  const activeTab = useSelector(getSelectActiveTabIndex);
  const { closeLeftTabs, closeRightTabs, updateCurrentTab } = useTabs();

  const params = queryParams();
  const { id, dealId, assetId, stipId } = params;

  const contact = useSWR<NContact.Entity>(`/${SERVICES.CONTACT}/contacts/${id}`);

  useEffect(() => {
    const fetchFiles = async () => {
      const data = await requestGetFiles(id ?? '', dealId ?? '', assetId ?? '');
      setFilesResponse(data);
    };

    if (id && stipId) {
      fetchFiles();
    }
  }, [id, dealId, assetId, stipId]);

  useEffect(() => {
    if (!filesResponse?.documents || !stipId) return;

    const matchedStip = filesResponse.documents.find((doc) => doc.contactStipId === stipId);

    setContactStipData(matchedStip ?? null);
  }, [filesResponse, stipId]);

  useEffect(() => {
    if (!contact) return;
    closeRightTabs(activeTab);
    closeLeftTabs(activeTab);

    const title = `${contact?.data?.firstName ?? ''} ${contact?.data?.lastName ?? ''} - STIPS Review`;

    const route = withQueryParams('/stips-review', {
      id,
      stipId,
    });

    updateCurrentTab({
      route,
      title,
    });
  }, [contact, activeTab, id, stipId, closeLeftTabs, closeRightTabs, updateCurrentTab]);

  if (!contactStipData) return null;

  return <StipsReview contactStipData={contactStipData} newTab={true}/>;
};
